import { Box, Chip, Typography } from "@mui/material";
import { IColorTokens } from "../../../../types/theme";
import { NotificationGroup } from "../types/types";

interface RecipientGroupsSelectorProps {
  groups: NotificationGroup[];
  selectedGroupIds: number[];
  onChange: (groupIds: number[]) => void;
  colors: IColorTokens;
}

export default function RecipientGroupsSelector({
  groups,
  selectedGroupIds,
  onChange,
  colors,
}: RecipientGroupsSelectorProps) {
  const toggle = (id: number) => {
    onChange(
      selectedGroupIds.includes(id)
        ? selectedGroupIds.filter((g) => g !== id)
        : [...selectedGroupIds, id],
    );
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 600, color: colors.primary[700], mb: 1.5 }}>
        Recipient Groups
      </Typography>
      {groups.length === 0 ? (
        <Typography variant="caption" sx={{ color: colors.primary[300] }}>
          No groups available.
        </Typography>
      ) : (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.25 }}>
          {groups.map((group) => {
            const selected = selectedGroupIds.includes(group.id);
            return (
              <Chip
                key={group.id}
                label={group.name}
                icon={selected ? <span style={{ fontSize: 14 }}>✓</span> : undefined}
                onClick={() => toggle(group.id)}
                sx={{
                  height: 40,
                  px: 1,
                  borderRadius: 5,
                  fontSize: "0.9rem",
                  fontWeight: 600,
                  cursor: "pointer",
                  bgcolor: selected ? colors.primary[400] : "transparent",
                  color: selected ? "#fff" : colors.primary[300],
                  border: `1px solid ${selected ? colors.primary[400] : colors.primary[800]}`,
                  "& .MuiChip-icon": { color: "#fff", ml: 1 },
                  "&:hover": {
                    bgcolor: selected ? colors.primary[500] : colors.primary[900],
                  },
                }}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
}
